const LocalMarketSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            <strong>El Paso Market</strong> Insights
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Understanding current market conditions helps us provide fair, competitive offers
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold mb-6 text-gray-900">
              Current Market Dynamics
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              The <strong>El Paso housing market</strong> has shown remarkable resilience and growth over the past several years. Our city has attracted attention from investors and homebuyers nationwide due to our affordable cost of living, strong job market, and quality of life. This increased interest has driven property values upward across most neighborhoods.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              However, market conditions vary significantly by neighborhood and property type. While some areas like East El Paso and the Westside have seen rapid appreciation, other neighborhoods have experienced more modest growth. Our deep understanding of these micro-markets ensures we can provide accurate valuations regardless of where your property is located.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Factors currently influencing the El Paso market include continued growth at Fort Bliss, expansion of the medical and education sectors, cross-border commerce dynamics, and the ongoing influx of remote workers choosing El Paso for its affordability and lifestyle. We monitor all these factors to ensure our offers reflect true market value.
            </p>
          </div>
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/67ea424a8a92bb9c0ddc82477a644041.jpg"
              alt="El Paso market analysis"
              className="w-full h-full rounded-xl shadow-xl object-cover"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-home-4-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-2xl font-bold mb-3 text-gray-900">Median Home Price</h4>
            <p className="text-gray-700 leading-relaxed">
              El Paso's median home price remains significantly below the national average, making our city one of the most affordable markets in Texas for both buyers and sellers.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-time-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-2xl font-bold mb-3 text-gray-900">Days on Market</h4>
            <p className="text-gray-700 leading-relaxed">
              Traditional listings in El Paso typically spend 30-60 days on the market. With us, you can close in as little as 7 days, eliminating months of uncertainty.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-arrow-up-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-2xl font-bold mb-3 text-gray-900">Market Appreciation</h4>
            <p className="text-gray-700 leading-relaxed">
              El Paso has experienced steady appreciation over the past decade, with certain neighborhoods seeing particularly strong growth in property values.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=El%20Paso%20Texas%20downtown%20skyline%20at%20sunset%2C%20modern%20city%20development%2C%20urban%20growth%2C%20business%20district%2C%20Rio%20Grande%20valley%2C%20Franklin%20Mountains%20backdrop%2C%20vibrant%20colors%2C%20professional%20cityscape%20photography&width=800&height=700&seq=elpasomarket002&orientation=portrait"
                alt="El Paso downtown development"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8 md:p-12">
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                Why El Paso is Growing
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-star-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Affordability:</strong> One of the most affordable major cities in the United States</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Job Growth:</strong> Expanding healthcare, education, and military sectors</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Quality of Life:</strong> 300+ days of sunshine, low crime, excellent schools</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Strategic Location:</strong> Gateway to Mexico and the Southwest</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Remote Work:</strong> Attracting professionals from high-cost areas</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalMarketSection;
